"use strict";
import { HttpRequest } from "../src/httpRequest";

const ServiceList = {
  categoryOptions: [],
  // ゲストの「フォロー中の会員のみ」のリセットを、結果表示まで保留する。
  // 検索時はフルページ遷移するため、このフラグも再初期化される。
  followingFilterReset: false,
  /**
   * 小カテゴリ選択フォーム用のカテゴリデータを取得する
   *
   */
  async fetchCategories() {
    const response = await HttpRequest.get(`/api/internal/v1/categories`);
    if (response.status != 200) {
      return;
    }
    const categoryOptions = {};
    const categories = await response.json();
    categories.forEach((parentCategory) => {
      const subCategories = parentCategory.sub_categories;
      const subCategoryOptions = subCategories.map((subCategory) => {
        return {
          subCategoryId: subCategory.id,
          subCategoryName: subCategory.name,
        };
      });

      categoryOptions[parentCategory.id] = subCategoryOptions;
    });
    this.categoryOptions = categoryOptions;
  },
  /**
   * SP版の検索モーダルで親カテゴリの選択に応じて小カテゴリを取得・表示する
   */
  replaceSubCategories() {
    // 小カテゴリのoptionを"すべて"以外削除する
    const subCategoryForm = document.getElementById("sub_category_sp");
    const optionGroup = subCategoryForm.querySelector("optgroup");
    while (optionGroup.childNodes.length > 2) {
      optionGroup.removeChild(optionGroup.lastChild);
    }
    // 選択した親カテゴリから小カテゴリを取得する
    const selectedCategoryId = document.getElementById("main_category_sp").value;
    if (selectedCategoryId === "") return;

    const subCategories = this.categoryOptions[selectedCategoryId];
    if (subCategories === undefined) return;

    // selectタグのoptionを取得した小カテゴリで置き換える
    subCategories.forEach((subCategory) => {
      const option = document.createElement("option");
      option.text = subCategory.subCategoryName;
      option.value = subCategory.subCategoryId;
      optionGroup.appendChild(option);
    });
    // 小カテゴリを選択可能にする
    subCategoryForm.disabled = false;
  },
  /**
   * サイドメニューの大カテゴリの開閉を行う
   *
   */
  toggleSubCategoryAccordion() {
    const target = window.event.currentTarget.parentNode;
    target.classList.toggle("open");
  },
  /**
   * サービス表示タイプの切り替え
   *
   */
  toggleServiceDisplayType() {
    const target = window.event.currentTarget;

    // 選択済みのボタンをクリックした場合には何もしない
    if (target.classList.contains("is_active")) return;

    // ボタン切り替え
    for (let sibling of target.parentNode.children) {
      if (sibling !== target) sibling.classList.remove("is_active");
    }
    target.classList.add("is_active");

    // 表示切り替え
    const serviceWrap = document.querySelector(".serviceWrap");

    if (serviceWrap.classList.contains("is_listType")) {
      serviceWrap.classList.remove("is_listType");
      serviceWrap.classList.add("is_cardType");
      localStorage.setItem("displayType", "cardType");
    } else {
      serviceWrap.classList.remove("is_cardType");
      serviceWrap.classList.add("is_listType");
      localStorage.setItem("displayType", "listType");
    }
  },
  /**
   * 保存しているサービス一覧の表示タイプ(カード/リスト)を読み込み
   * デフォルトはカード表示
   *
   */
  loadDisplayType() {
    const displayType = localStorage.getItem("displayType");
    const serviceWrap = document.querySelector(".serviceWrap");
    if (displayType === "listType") {
      document.getElementById("listTypeButton").classList.add("is_active");
      document.getElementById("cardTypeButton").classList.remove("is_active");
      serviceWrap.classList.add("is_listType");
      serviceWrap.classList.remove("is_cardType");
    }
  },
  /**
   * カテゴリ絞り込みを無効にして全カテゴリでのサービス一覧を表示する
   *
   */
  moveToAllCategories() {
    // TODO 検索結果に連動するように修正
    const form = document.getElementById("serviceSearchForm");
    const selectForm = document.getElementById("headerSelectCategory");
    selectForm.selectedIndex = -1;
    document.getElementById("hiddenSubCategory").value = "";
    form.submit();
  },
  /**
   * (PC版)サイドバーから大カテゴリを選択する
   *
   */
  onSelectParentCategory(parentCategoryId) {
    const form = document.getElementById("serviceSearchForm");
    const parentCategorySelect = document.getElementById("headerSelectCategory");
    parentCategorySelect.value = parentCategoryId;
    const hiddenSubCategory = document.getElementById("hiddenSubCategory");
    hiddenSubCategory.remove();
    form.submit();
  },
  /**
   * (PC版)サイドバーから小カテゴリを選択する
   *
   */
  onSelectSubCategory(parentCategoryId, subCategoryId) {
    const form = document.getElementById("serviceSearchForm");
    const parentCategorySelect = document.getElementById("headerSelectCategory");
    parentCategorySelect.value = parentCategoryId;
    const hiddenSubCategory = document.getElementById("hiddenSubCategory");
    hiddenSubCategory.value = subCategoryId;
    form.submit();
  },
  /**
   * (SP版)フッターから大カテゴリ（すべて）を選択する
   *
   */
  onSelectParentCategorySp(parentCategoryId) {
    const form = document.getElementById("categoryListFormSp");
    const hiddenSubCategory = document.getElementById("footerSubCategorySp");
    const hiddenParentCategory = document.getElementById("footerParentCategorySp");
    hiddenParentCategory.value = parentCategoryId;
    form.submit();
  },
  /**
   * (SP版)フッターから小カテゴリを選択する
   *
   */
  onSelectSubCategorySp(parentCategoryId, subCategoryId) {
    const form = document.getElementById("categoryListFormSp");
    const hiddenSubCategory = document.getElementById("footerSubCategorySp");
    const hiddenParentCategory = document.getElementById("footerParentCategorySp");
    hiddenParentCategory.value = parentCategoryId;
    hiddenSubCategory.value = subCategoryId;
    form.submit();
  },
  /**
   * SP版の絞り込みモーダルからカテゴリを絞り込む
   *
   */
  filterCategoryFromModal() {
    const form = document.getElementById("serviceSearchForm");
    // 大カテゴリのパラメータを選択したものにする
    const modalParentCategory = document.getElementById("main_category_sp");
    const parentCategoryId = modalParentCategory.selectedOptions[0].value;
    const parentCategorySelect = document.getElementById("headerSelectCategory");
    parentCategorySelect.value = parentCategoryId;

    const hiddenSubCategory = document.getElementById("hiddenSubCategory");
    const selectedOption = document.getElementById("sub_category_sp").selectedOptions[0];
    const selectedText = selectedOption.textContent;

    if (selectedText === "すべて") {
      // 小カテゴリで「すべて」を選択している場合、ヘッダー検索欄のカテゴリを選択したものに変える
      hiddenSubCategory.remove();
    } else {
      // 他の小カテゴリを選択している場合、小カテゴリのhiddenパラメータを選択したものに変える
      const subCategoryId = selectedOption.value;
      hiddenSubCategory.value = subCategoryId;
    }
    // 「受付中のみ」のチェック状態を反映させる
    const acceptingCheck = document.getElementById("check_display_md");
    const accepting = acceptingCheck.checked;
    const hiddenAccepting = document.getElementById("accepting");
    hiddenAccepting.value = accepting;
    // 「価格帯」を反映させる
    const Rewardlower = document.getElementById("reward_lower_sp").value;
    const hiddenRewardLower = document.getElementById("hiddenRewardLower");
    hiddenRewardLower.value = Rewardlower;
    const rewardUpper = document.getElementById("reward_upper_sp").value;
    const hiddenRewardUpper = document.getElementById("hiddenRewardUpper");
    hiddenRewardUpper.value = rewardUpper;
    // 会員区分を反映させる
    const hiddenRankTora = document.getElementById("hiddenRankTora");
    hiddenRankTora.value = document.getElementById("sp_tora").checked;
    const hiddenRankPanda = document.getElementById("hiddenRankPanda");
    hiddenRankPanda.value = document.getElementById("sp_panda").checked;
    const hiddenRankIruka = document.getElementById("hiddenRankIruka");
    hiddenRankIruka.value = document.getElementById("sp_iruka").checked;
    const hiddenRankPengin = document.getElementById("hiddenRankPengin");
    hiddenRankPengin.value = document.getElementById("sp_pengin").checked;
    const hiddenRankKodomo = document.getElementById("hiddenRankKodomo");
    hiddenRankKodomo.value = document.getElementById("sp_kodomo").checked;
    // 「ビギナー出品者のみ」のチェック状態を反映させる
    const beginnerCheck = document.getElementById("checkbox_beginner_sp");
    const hiddenBeginner = document.getElementById("hiddenBeginner");
    hiddenBeginner.value = beginnerCheck.checked;

    const followingCheck = document.getElementById("checkbox_followedMember_SP");
    if (followingCheck) {
      document.getElementById("hiddenFollowingOnly").value = followingCheck.checked;
    } else if (this.followingFilterReset) {
      document.getElementById("hiddenFollowingOnly").value = false;
    }

    form.submit();
  },
  /**
   * サイドバー「受付中のみ」のチェックの値の切り替わりをトリガーに絞り込み処理を実行する
   *
   */
  toggleReceptionStatusFiltering() {
    const form = document.getElementById("serviceSearchForm");
    // 受付中のみ　の状態を反映
    const acceptingCheck = document.getElementById("checkbox_display");
    const accepting = acceptingCheck.checked;
    const hiddenAccepting = document.getElementById("accepting");
    hiddenAccepting.value = accepting;
    form.submit();
  },
  /**
   * サイドバー「ビギナー出品者のみ」のチェックの値の切り替わりをトリガーに絞り込み処理を実行する
   *
   */
  toggleBeginnerFiltering() {
    const form = document.getElementById("serviceSearchForm");
    const beginnerCheck = document.getElementById("checkbox_beginner");
    const beginner = beginnerCheck.checked;
    const hiddenBeginner = document.getElementById("hiddenBeginner");
    hiddenBeginner.value = beginner;
    form.submit();
  },
  /**
   * PCの「フォロー中の会員のみ」を検索条件に反映する
   */
  toggleFollowingFiltering() {
    const followingCheck = document.getElementById("checkbox_followedMember");
    document.getElementById("hiddenFollowingOnly").value = followingCheck.checked;
    document.getElementById("serviceSearchForm").submit();
  },
  /**
   * 「フォロー中の会員のみ」の検索条件タグを解除する
   */
  clearFollowingFilter() {
    document.getElementById("hiddenFollowingOnly").value = false;
    document.getElementById("serviceSearchForm").submit();
  },
  /**
   * 並び替えを選択するとフォームを送信する
   *
   */
  sortServices() {
    const form = document.getElementById("serviceSearchForm");
    const sortSelect = document.getElementById("sortSelect");
    const hiddenSort = document.getElementById("hiddenSort");
    hiddenSort.value = sortSelect.value;
    form.submit();
  },
  /**
   * 検索条件をクリアする(SP版モーダル)
   *
   */
  clearSearchCondition() {
    const rewardLower = document.getElementById("reward_lower_sp");
    rewardLower.selectedIndex = 0;
    const rewardUpper = document.getElementById("reward_upper_sp");
    rewardUpper.selectedIndex = 0;
    const parentCategorySelect = document.getElementById("main_category_sp");
    parentCategorySelect.selectedIndex = 0;
    const subCategorySelect = document.getElementById("sub_category_sp");
    subCategorySelect.selectedIndex = 0;
    subCategorySelect.disabled = true;
    const checkDisplay = document.getElementById("check_display_md");
    checkDisplay.checked = false;
    const checkBeginner = document.getElementById("checkbox_beginner_sp");
    checkBeginner.checked = false;

    const followingCheck = document.getElementById("checkbox_followedMember_SP");
    if (followingCheck) followingCheck.checked = false;
    this.followingFilterReset = true;

    const statusTora = document.getElementById("sp_tora");
    statusTora.checked = true;
    statusTora.parentElement.classList.remove("is_uncheck");

    const statusPanda = document.getElementById("sp_panda");
    statusPanda.checked = true;
    statusPanda.parentElement.classList.remove("is_uncheck");

    const statusIruka = document.getElementById("sp_iruka");
    statusIruka.checked = true;
    statusIruka.parentElement.classList.remove("is_uncheck");

    const statusPengin = document.getElementById("sp_pengin");
    statusPengin.checked = true;
    statusPengin.parentElement.classList.remove("is_uncheck");

    const statusKodomo = document.getElementById("sp_kodomo");
    statusKodomo.checked = true;
    statusKodomo.parentElement.classList.remove("is_uncheck");
  },
  /**
   * 価格帯の「絞り込む」ボタンクリック時処理
   *
   */
  onFilteringPriceRange() {
    const form = document.getElementById("serviceSearchForm");
    const Rewardlower = document.getElementById("reward_lower").value;
    const hiddenRewardLower = document.getElementById("hiddenRewardLower");
    hiddenRewardLower.value = Rewardlower;
    const rewardUpper = document.getElementById("reward_upper").value;
    const hiddenRewardUpper = document.getElementById("hiddenRewardUpper");
    hiddenRewardUpper.value = rewardUpper;

    const hiddenRankTora = document.getElementById("hiddenRankTora");
    hiddenRankTora.value = document.getElementById("tora").checked;

    const hiddenRankPanda = document.getElementById("hiddenRankPanda");
    hiddenRankPanda.value = document.getElementById("panda").checked;

    const hiddenRankIruka = document.getElementById("hiddenRankIruka");
    hiddenRankIruka.value = document.getElementById("iruka").checked;

    const hiddenRankPengin = document.getElementById("hiddenRankPengin");
    hiddenRankPengin.value = document.getElementById("pengin").checked;

    const hiddenRankKodomo = document.getElementById("hiddenRankKodomo");
    hiddenRankKodomo.value = document.getElementById("kodomo").checked;
    form.submit();
  },
  /**
   * 価格帯表示の「✗」マーククリック時処理
   *
   */
  clearPriceRange() {
    const form = document.getElementById("serviceSearchForm");
    const hiddenRewardLower = document.getElementById("hiddenRewardLower");
    hiddenRewardLower.value = "";
    const hiddenRewardUpper = document.getElementById("hiddenRewardUpper");
    hiddenRewardUpper.value = "";
    form.submit();
  },
  /**
   * スマホ：ツールチップ表示（※PCはcssのみで制御）
   */
  showToolHint: () => {
    const toolhints = document.querySelectorAll(".toolhint");

    if (toolhints.length === 0) return;

    // 各ツールヒント要素にクリックイベントを設定
    toolhints.forEach((toolhint) => {
      toolhint.addEventListener("click", (e) => {
        e.currentTarget.querySelector(".tip").classList.toggle("is_show");
      });
    });

    // ツールヒント以外をタップした場合、全てのツールヒントを閉じる
    document.addEventListener("touchend", (e) => {
      if (e.target.closest(".toolhint") === null) {
        toolhints.forEach((toolhint) => {
          toolhint.querySelector(".tip").classList.remove("is_show");
        });
      }
    });
  },
};

// ページロード後にグローバル定数にServicesFormを追加する
document.addEventListener("DOMContentLoaded", () => {
  ServiceList.loadDisplayType();
  ServiceList.showToolHint();
  Object.defineProperty(globalThis, "ServiceList", {
    value: ServiceList,
    writable: false,
    configurable: true,
  });

  // ------------------------------------------------------
  // iOS Safari の一部で HTML の onclick が動作しない件に対応
  // ------------------------------------------------------

  // 小カテゴリ「すべて」のクリック時（大カテゴリで検索）
  let selectParentCategories = document.querySelectorAll(".onSelectParentCategorySp");
  selectParentCategories.forEach(function(selectCategory) {
    selectCategory.addEventListener("click", function() {
      const parentCategoryId = this.dataset.parentCategoryId;
      ServiceList.onSelectParentCategorySp(parentCategoryId);
    });
  });

  // 小カテゴリクリック時
  let selectSubCategories = document.querySelectorAll(".onSelectSubCategorySp");
  selectSubCategories.forEach(function(selectCategory) {
    selectCategory.addEventListener("click", function() {
      const parentCategoryId = this.dataset.parentCategoryId;
      const subCategoryId = this.dataset.subCategoryId;
      ServiceList.onSelectSubCategorySp(parentCategoryId, subCategoryId);
    });
  });

  // SP用 検索モーダルの大カテゴリ選択時の処理
  let mainCategorySelect = document.getElementById("main_category_sp");
  if (mainCategorySelect) {
    mainCategorySelect.addEventListener("change", function() {
      ServiceList.replaceSubCategories();
    });
  }

  // SP用「検索する」ボタンの処理
  let searchBtn = document.getElementById("sp_search");
  if (searchBtn) {
    searchBtn.addEventListener("click", function() {
      ServiceList.filterCategoryFromModal();
    });
  }

  // SP用「検索条件をリセット」ボタンの処理
  let clearBtn = document.getElementById("sp_clear");
  if (clearBtn) {
    clearBtn.addEventListener("click", function() {
      ServiceList.clearSearchCondition();
    });
  }
});

// 大カテゴリクリック時のメニュー開閉
document.querySelectorAll(".main_cat_inner").forEach((element) => {
  element.addEventListener("click", ServiceList.toggleSubCategoryAccordion);
});
